// initial state
const state = () => ({
    //
})

// getters
const getters = {
    //
}

// actions
const actions = {
    createPaymentIntent: async({ commit }, user) => {
        let { data } = await axios.get('payment/setup');
        return data;
    },

    getPlans: async({ commit }) => {
        let { data } = await axios.get('payment/plans');
        return data;
    },

    swapSubscriptionPackage: async({ commit }, plan) => {
        let { data } = await axios.post('swap-subscription-package', { "newSubscription": plan });
        return data;
    }
}

// mutations
const mutations = {
    //
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
